import React from 'react';
import './Readers.css';

const readerImages = [
  '/images/610607321_18550946542061254_4865384346161932878_n.jpg',
  '/images/611653675_18551086213061254_217163455228384709_n.jpg',
  '/images/615556629_18552074101061254_974880831430855947_n.jpg',
  '/images/619239619_18553732969061254_2050848146024248697_n.jpg',
  '/images/624285982_18555106189061254_2102130353205777108_n.jpg',
  '/images/625964806_18555679393061254_2578704768291344222_n.jpg',
];

function Readers() {
  return (
    <section className="readers-section" id="readers">
      <div className="readers-inner">
        <div className="readers-header reveal">
          <h2>READERS WITH SAVING GRACE</h2>
          <div className="red-rule"></div>
        </div>
        <div className="readers-grid reveal">
          {readerImages.map((src, i) => (
            <div className="reader-photo" key={i}>
              <img src={src} alt="Reader with Saving Grace" />
            </div>
          ))}
        </div>
        <p className="readers-cta reveal">Share your photo with #SavingGrace</p>
      </div>
    </section>
  );
}

export default Readers;
